import { useEffect, useState } from "react";
import { BrowserRouter, Routes, Route, Navigate, useLocation } from "react-router-dom";
import "@/App.css";
import { AuthProvider, useAuth } from "@/context/AuthContext";
import LoadingScreen from "@/pages/LoadingScreen";
import Login from "@/pages/Login";
import ClientDashboard from "@/pages/ClientDashboard";
import AdminDashboard from "@/pages/AdminDashboard";

function Protected({ children, role }) {
  const { user } = useAuth();
  const loc = useLocation();
  if (user === null) {
    // checking session
    return (
      <div className="flex min-h-screen items-center justify-center bg-[#05080f] text-white/60">
        Verificando sesión...
      </div>
    );
  }
  if (!user) return <Navigate to="/login" replace state={{ from: loc }} />;
  if (role && user.role !== role) {
    return <Navigate to={user.role === "admin" ? "/admin" : "/dashboard"} replace />;
  }
  return children;
}

function RootRedirect() {
  const { user } = useAuth();
  if (user === null) return null;
  if (!user) return <Navigate to="/login" replace />;
  return <Navigate to={user.role === "admin" ? "/admin" : "/dashboard"} replace />;
}

function AppRoutes() {
  const [intro, setIntro] = useState(() => {
    // Show intro only once per browser session
    return !sessionStorage.getItem("pg_intro_done");
  });

  if (intro) {
    return (
      <LoadingScreen
        durationMs={5000}
        onDone={() => {
          sessionStorage.setItem("pg_intro_done", "1");
          setIntro(false);
        }}
      />
    );
  }

  return (
    <Routes>
      <Route path="/login" element={<Login />} />
      <Route
        path="/dashboard"
        element={
          <Protected role="client">
            <ClientDashboard />
          </Protected>
        }
      />
      <Route
        path="/admin"
        element={
          <Protected role="admin">
            <AdminDashboard />
          </Protected>
        }
      />
      <Route path="/" element={<RootRedirect />} />
      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
  );
}

function App() {
  // Disable global right-click + selection by default (also enforced inside ScreenProtection)
  useEffect(() => {
    const onCtx = (e) => e.preventDefault();
    document.addEventListener("contextmenu", onCtx);
    return () => document.removeEventListener("contextmenu", onCtx);
  }, []);

  return (
    <div className="App min-h-screen bg-[#05080f] text-white">
      <BrowserRouter>
        <AuthProvider>
          <AppRoutes />
        </AuthProvider>
      </BrowserRouter>
    </div>
  );
}

export default App;
